export const initDashboard = () => ({
  type: "INIT_DASHBOARD"
});

export const setDashboardOrganization = organization => ({
  type: "SET_DASHBOARD_ORGANIZATION",
  organization
});

export const setAttachmentFileLink = attachmentFileLink => ({
  type: "SET_ATTACHMENT_FILE_LINK",
  attachmentFileLink
});

export const setDashboardSlides = slides => ({
  type: "SET_DASHBOARD_SLIDES",
  slides
});

export const fetchDashboard = data => ({
  type: "FETCH_DASHBOARD",
  payload: data
});

export const fetchGeneralAssociationDashboard = data => {
  return {
    type: "FETCH_GENERAL_ASSOCIATION_DASHBOARD",
    payload: data
  };
};

export const setGeneralAssociationDashboard = selected => {
  return {
    type: "SET_GENERAL_ASSOCIATION_DASHBOARD",
    payload: selected
  };
};

export const saveGeneralAssociationDashboard = resp => {
  return {
    type: "SAVE_GENERAL_ASSOCIATION_DASHBOARD",
    payload: resp
  };
};



// WEBPACK FOOTER //
// ./src/actions/actions/dashboard.js